import React, { useRef } from 'react';
import { Box, Button } from '@radix-ui/themes';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import './style.scss';

import logoRsw from '../../../assets/images/logo/logo_rsw.png';
import logoGw from '../../../assets/images/logo/logo_gw.png';
import logoGk from '../../../assets/images/logo/logo_gk.png';
import logoIc from '../../../assets/images/logo/logo_ic.png';
import logoCb from '../../../assets/images/logo/logo_cb.png';
import logoCn from '../../../assets/images/logo/logo_cn.png';
import logoJn from '../../../assets/images/logo/logo_jn.png';
import logoJb from '../../../assets/images/logo/logo_jb.png';
import logoGj from '../../../assets/images/logo/logo_gj.png';
import logoGb from '../../../assets/images/logo/logo_gb.png';
import logoGn from '../../../assets/images/logo/logo_gn.png';
import logoDg from '../../../assets/images/logo/logo_dg.png';
import logoWs from '../../../assets/images/logo/logo_ws.png';
import logoJj from '../../../assets/images/logo/logo_jj.png';

const IMAGES = {
  imgPartner1: {
    src: 'https://www.msit.go.kr/images/user/logo/logo.svg',
    alt: '과학기술정보통신부',
    url: 'https://www.msit.go.kr/',
    target: '_blank'
  },
  imgPartner2: {
    src: 'https://www.nipa.kr/humanframe/theme/home/assets/img/nipaLogo.png',
    alt: 'NIPA 정보통신산업진흥원',
    url: 'https://www.nipa.kr/',
    target: '_blank'
  },
  imgPartner3: {
    src: logoRsw,
    alt: '지역SW산업발전협의회',
    url: 'http://rsw.or.kr/',
    target: '_blank'
  },
  imgPartner4: {
    src: 'https://about.ebs.co.kr/kor/images/respond/common/ebs_logo.png',
    alt: 'EBS',
    url: 'https://ebs.co.kr/',
    target: '_blank'
  },
  imgPartner5: {
    src: logoGw,
    alt: 'GSIPA 강릉과학산업진흥원',
    url: 'https://mybiz.gsipa.or.kr',
    target: '_blank'
  },
  imgPartner6: {
    src: logoGk,
    alt: 'GBSA 경기도경제과학진흥원',
    url: 'https://www.gbsa.or.kr',
    target: '_blank'
  },
  imgPartner7: {
    src: logoIc,
    alt: 'ITP 인천테크노파크',
    url: 'https://www.itp.or.kr/',
    target: '_blank'
  },
  imgPartner8: {
    src: logoCb,
    alt: 'CBIST 충북과학기술혁신원',
    url: 'https://www.cbist.or.kr/',
    target: '_blank'
  },
  imgPartner9: {
    src: logoCn,
    alt: '남서울대학교',
    url: 'https://www.nsu.ac.kr/',
    target: '_blank'
  },
  imgPartner10: {
    src: logoJn,
    alt: 'JCIA (재)전남정보문화산업진흥원',
    url: 'https://www.jcia.or.kr/',
    target: '_blank'
  },
  imgPartner11: {
    src: logoJb,
    alt: 'JBTP (재)전북테크노파크',
    url: 'https://www.jbtp.or.kr/',
    target: '_blank'
  },
  imgPartner12: {
    src: logoGj,
    alt: 'GICON 광주정보문화산업진흥원',
    url: 'https://www.gicon.or.kr/',
    target: '_blank'
  },
  imgPartner13: {
    src: logoGb,
    alt: '경북디지털혁신본부',
    url: 'http://gbsw.or.kr/',
    target: '_blank'
  },
  imgPartner14: {
    src: logoGn,
    alt: '경남테크노파크',
    url: 'https://www.gntp.or.kr/',
    target: '_blank'
  },
  imgPartner15: {
    src: logoDg,
    alt: '대구디지털혁신진흥원',
    url: 'https://www.dip.or.kr/',
    target: '_blank'
  },
  imgPartner16: {
    src: logoWs,
    alt: 'UIPA 울산정보산업진흥원',
    url: 'https://uipa.or.kr/',
    target: '_blank'
  },
  imgPartner17: {
    src: logoJj,
    alt: 'TMD교육그룹',
    url: 'http://tmdedu.com/',
    target: '_blank'
  }
};

export const PartnerSlider = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const swiperRef = useRef(null);

  const updateFocus = swiper => {
    // 복제 슬라이드 포함 전체 비활성화
    swiper.slides.forEach(slide => {
      const link = slide.querySelector('a');
      if (link) link.setAttribute('tabIndex', '-1');
    });

    // realIndex 기준으로 실제 슬라이드만 활성화 (loop 복제본 제외)
    const realIndex = swiper.realIndex;
    swiper.slides.forEach(slide => {
      const slideIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
      if (slideIndex === realIndex) {
        const link = slide.querySelector('a');
        if (link) link.setAttribute('tabIndex', '0');
      }
    });
  };

  const handleSwiperInit = swiper => {
    swiperRef.current = swiper;

    const container = swiper.el;

    // 키보드 접근성
    container.addEventListener('focusin', () => {
      swiperRef.current?.autoplay?.stop();
    });

    container.addEventListener('focusout', () => {
      swiperRef.current?.autoplay?.start();
    });

    // 마우스 hover 접근성
    container.addEventListener('mouseenter', () => {
      swiperRef.current?.autoplay?.stop();
    });

    container.addEventListener('mouseleave', () => {
      swiperRef.current?.autoplay?.start();
    });
  };

  return (
    <>
      <Box className="partner-slider">
        <Swiper
          aria-label="함께하는 기관 슬라이더"
          autoplay={{
            delay: 1500,
            disableOnInteraction: true
          }}
          loop={true}
          slidesPerView={'auto'}
          spaceBetween={8}
          modules={[Autoplay, Navigation]}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current
          }}
          onBeforeInit={swiper => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          onSwiper={handleSwiperInit}
          onInit={updateFocus}
          onSlideChangeTransitionEnd={updateFocus}
        >
          {Object.keys(IMAGES).map((key, index) => (
            <SwiperSlide className="slider-item" key={index}>
              <a href={IMAGES[key].url} target="_blank" rel="noopener noreferrer" aria-label={`${IMAGES[key].alt} - 새 창 열림`}>
                <img
                  src={IMAGES[key].src}
                  alt={IMAGES[key].alt}
                  onError={e => {
                    console.error(`이미지 로드 실패: ${IMAGES[key].alt}`, e);
                  }}
                />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
        <Box className="slider-btn-box">
          <Button aria-label="이전 슬라이드" className="slider-prev" ref={prevRef}>
            Prev
          </Button>
          <Button aria-label="다음 슬라이드" className="slider-next" ref={nextRef}>
            Next
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default PartnerSlider;
